import { render, staticRenderFns } from "./RichTextEditorMedicalContentImage.vue?vue&type=template&id=b27dd14a&scoped=true&"
import script from "./RichTextEditorMedicalContentImage.vue?vue&type=script&lang=js&"
export * from "./RichTextEditorMedicalContentImage.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditorMedicalContentImage.vue?vue&type=style&index=0&id=b27dd14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27dd14a",
  null
  
)

export default component.exports